"use strict";

function n(n) {
  return n && "object" == typeof n && "default" in n ? n.default : n;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var t = require("react"),
    e = n(t),
    r = n(require("react-resize-detector")),
    i = require("react-swipeable"),
    a = require("styled-components"),
    o = n(a),
    u = function u(n) {
  return e.createElement("svg", Object.assign({}, n, {
    viewBox: "0 0 42 42"
  }), e.createElement("path", {
    d: "M36.07 20.18l-29-20A1 1 0 005.5 1v40a1 1 0 001.57.82l29-20a1 1 0 000-1.64z"
  }));
};

function c(n, t) {
  return t || (t = n.slice(0)), n.raw = t, n;
}

function s() {
  var n = c(["\n            width: 100%;\n            flex-basis: 100%;\n          "]);
  return s = function s() {
    return n;
  }, n;
}

function l() {
  var n = c(["\n            right: 5px;\n          "]);
  return l = function l() {
    return n;
  }, n;
}

function f() {
  var n = c(["\n            left: 5px;\n          "]);
  return f = function f() {
    return n;
  }, n;
}

function d() {
  var n = c(["\n            width: calc(100% - 80px);\n            padding: 0 40px;\n          "]);
  return d = function d() {
    return n;
  }, n;
}

function p() {
  var n = c(["\n  position: relative;\n\n  ", " {\n    ", "\n  }\n\n  ", " {\n    ", "\n  }\n\n  ", " {\n    ", "\n  }\n\n  ", " {\n    ", "\n  }\n"]);
  return p = function p() {
    return n;
  }, n;
}

function m() {
  var n = c(["\n  transition: 0.3s left;\n  position: relative;\n  width: ", "%;\n  flex: 0 0 ", "%;\n  display: flex;\n"]);
  return m = function m() {
    return n;
  }, n;
}

function v() {
  var n = c(["\n  ", ";\n  opacity: ", ";\n  right: 10px;\n"]);
  return v = function v() {
    return n;
  }, n;
}

function g() {
  var n = c(["\n  ", ";\n  opacity: ", ";\n  left: 10px;\n\n  svg {\n    transform: scale(-1);\n  }\n"]);
  return g = function g() {
    return n;
  }, n;
}

function x() {
  var n = c(["\n  box-sizing: content-box;\n  cursor: pointer;\n  background: #fff;\n  border: 0;\n  color: ", ";\n  border-radius: 4px;\n  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);\n  font-size: 12px;\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  top: 50%;\n  margin-top: -15px;\n  z-index: 1;\n  transition: 0.3s opacity;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & svg {\n    width: 13px;\n  }\n"]);
  return x = function x() {
    return n;
  }, n;
}

function h() {
  var n = c(["\n  box-sizing: content-box;\n  display: flex;\n  flex-wrap: nowrap;\n  width: calc(100% - 120px);\n  margin: 0;\n  padding: 0 60px;\n  mask-image: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    color-stop(0, rgba(0, 0, 0, 0)),\n    color-stop(0.05, rgba(0, 0, 0, 1)),\n    color-stop(0.95, rgba(0, 0, 0, 1)),\n    color-stop(1, rgba(0, 0, 0, 0))\n  );\n  overflow: hidden;\n"]);
  return h = function h() {
    return n;
  }, n;
}

var b = function b(n) {
  return "xs" === n || "sm" === n;
},
    w = o.div(h()),
    y = a.css(x(), "#105783"),
    E = o.button(g(), y, function (n) {
  return n.faded ? .25 : 1;
}),
    S = o.button(v(), y, function (n) {
  return n.faded ? .25 : 1;
}),
    k = o.div(m(), function (n) {
  return 100 / n.itemsWide;
}, function (n) {
  return 100 / n.itemsWide;
}),
    z = o.div(p(), w, function (n) {
  return b(n.media) ? a.css(d()) : null;
}, E, function (n) {
  return b(n.media) ? a.css(f()) : null;
}, S, function (n) {
  return b(n.media) ? a.css(l()) : null;
}, k, function (n) {
  return b(n.media) ? a.css(s()) : null;
});

exports.default = function (n) {
  var e = n.items,
      a = void 0 === e ? [] : e,
      o = n.itemsWide,
      c = void 0 === o ? 3 : o,
      s = n.infinity,
      l = void 0 !== s && s,
      f = n.canvasClassName,
      d = n.canvasStyle,
      p = n.arrowClassName,
      m = n.arrowStyle,
      v = n.style,
      g = t.useState(0),
      x = g[0],
      h = g[1],
      b = t.useState(0),
      y = b[0],
      j = b[1],
      N = t.useState(null),
      W = N[0],
      q = N[1],
      C = t.useState(0),
      M = C[0],
      O = C[1],
      T = function T() {
    return M <= 767 ? 1 : c;
  },
      D = function D() {
    return l && a.length > 1 || 0 !== x;
  },
      _ = function _() {
    var n = T();
    return l && a.length > 1 || x < a.length - n;
  },
      A = function A() {
    if (D()) {
      var n = T();
      h((a.length + x - (0 === x ? n : 1)) % a.length);
    }
  },
      B = function B() {
    if (_()) {
      var n = T();
      h((a.length + x + (a.length - x > n ? 1 : n)) % a.length);
    }
  },
      I = function I() {
    var n = new Date().getTime();
    j(0), q(n);
  },
      P = a.length <= c;

  return t.createElement(r, {
    handleWidth: !0,
    onResize: function onResize(n) {
      O(n), I();
    }
  }, t.createElement(z, {
    style: v,
    media: M <= 576 ? "xs" : M <= 767 ? "sm" : "md"
  }, !P && t.createElement(E, {
    "data-testid": "prev",
    faded: !D(),
    onClick: A,
    className: p,
    style: m
  }, t.createElement(u, null)), t.createElement(i.Swipeable, Object.assign({
    onSwiping: function onSwiping(n) {
      return function (n) {
        var t = new Date().getTime();

        if (M && !(W && t - W < 250)) {
          var e = 2 * n.deltaX / M;
          return j(100 * e), e < -.3333 ? (I(), void A()) : e > .3333 ? (I(), void B()) : void 0;
        }
      }(n);
    },
    onSwiped: function onSwiped() {
      j(0);
    }
  }, {
    trackTouch: !0,
    trackMouse: !0
  }), t.createElement(w, {
    className: f,
    style: d
  }, a.map(function (n, e) {
    return t.createElement(k, {
      key: e,
      itemsWide: T(),
      currentIndex: x,
      "data-testid": "item",
      style: {
        left: "-" + (100 * x / T() + y) + "%"
      }
    }, n);
  }))), !P && t.createElement(S, {
    "data-testid": "next",
    faded: !_(),
    onClick: B,
    className: p,
    style: m
  }, t.createElement(u, null))));
};